<template>
  <div>
    <v-row no-gutters v-if="fieldsLoading">
      <v-col v-for="n in 9" :key="n" cols="12" sm="6" lg="3">
       <v-sheet class="mt-2">
        <v-skeleton-loader class="mx-auto" type="list-item"></v-skeleton-loader>
      </v-sheet>
      </v-col>
    </v-row>
    <form-data v-else :references.sync="formReferences" :model="modelObj" ref="deviationReference">
      <template slot="extraDetails" v-if="modelObj.id">
        <div class="pa-2">
          <v-expansion-panels>
            <attachments :model="modelObj" v-if="modelObj.id" :key="reInit" :module="SP_DEVIATION"></attachments>
          </v-expansion-panels>
          <v-expansion-panels v-model="measurePanel">
            <v-expansion-panel class="mt-2">
              <v-expansion-panel-header color="primary" style="color: white;" class="expansion--panel">
                <v-row no-gutters>
                  <v-col cols="4">
                    <v-icon dark>mdi-folder-alert-outline</v-icon>
                    {{ $t('message.deviations.measures') }}
                  </v-col>
                </v-row>
              </v-expansion-panel-header>
              <v-expansion-panel-content class="pt-0">
                <deviation-measure :deviationObj="modelObj" @reload="getSingleRecordHandler"></deviation-measure>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>
      </template>
    </form-data>
    <v-dialog v-model="shareDialog" persistent max-width="1150px" class="mt-0">
      <v-form ref="sendEmailForm" onSubmit="return false;">
        <v-card>
          <v-card-title>
            {{ $t('message.invoice.resendEmail') }}
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="pa-2">
            <v-col cols="12">
              <v-row class="mt-4">
                <v-text-field outlined dense v-model="mail.emailIds" ref="autoFocus" :rules="$_requiredValidation"
                  :label="$t('message.user.email')"
                  persistent-hint :hint="$t('message.common.add_extra_mails')"></v-text-field>
              </v-row>
              <v-row class="mt-4">
                <v-text-field outlined dense v-model="mail.subject" :rules="$_requiredValidation"
                  persistent-hint :hint="$t('message.tickets.subject')"></v-text-field>
              </v-row>
              <v-row>
                <v-flex xs12>
                  <label class="subtitle-1">{{ $t('message.tickets.body') }}</label>
                  <ckeditor :editor="editor" v-model="mail.body" :config="configEditor"></ckeditor>
                </v-flex>
              </v-row>
            </v-col>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="success" id="sendMail" :loading="shareLoading" @click="sendReport">{{ $t('message.common.send') }}</v-btn>
            <v-btn color="error" id="close" @click="closeShareDialog">{{ $t('message.common.close') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </div>
</template>
<script>
/* eslint-disable camelcase */
import { mapState } from 'vuex'
import FormTemplate from '../../components/FormTemplate'
import deviationReport from '@/mixins/Deviation/index'
import axios from 'axios'
import Editor from '@/ckeditor'
// import { getFooter } from '@/constants'
export default {
  data () {
    return {
      modelObj: {
        id: this.$route.params.deviation_id
      },
      fieldsLoading: false,
      loading: false,
      MODULE_URL: 'deviations',
      listUsers: [],
      listOfOrders: [],
      orderLoading: false,
      reInit: 0,
      isCopyToMe: false,
      downloadLoading: false,
      canReloadDocument: false,
      shareDialog: false,
      shareLoading: false,
      mail: {
        subject: '',
        body: ''
      },
      editor: Editor,
      configEditor: {
        toolbar: {
          items: [
            'heading',
            '|',
            'bold',
            'italic',
            '|',
            'bulletedList',
            'numberedList',
            '|',
            'undo',
            'redo'
          ]
        }
      },
      settingsObj: {},
      measurePanel: 1,
      hasMeasures: 0
    }
  },
  components: {
    'form-data': FormTemplate,
    'deviation-measure': () => import('./Measures.vue'),
    'attachments': () => import('@/components/Attachments')
  },
  mixins: [deviationReport],
  computed: {
    ...mapState(['FORM_TYPE', 'userDetails', 'listOfUsers', 'listOfDevationStatus', 'listOfDevationLocation', 'listOfDevationCategory']),
    formReferences () {
      let props = {
        title: this.$route.params.deviation_id ? `${this.modelObj.number ? this.modelObj.number + ' - ' : ''} ${this.$t('message.deviations.updateDeviation')}` : this.$t('message.deviations.addDeviation'),
        properties: [{
          model: 'title',
          type: this.FORM_TYPE.TEXT,
          rules: this.$_requiredValidation,
          label: this.$t('message.deviations.title'),
          class: 'lg4 md4 sm6',
          change: this.changesMade
        }, {
          model: 'order_id',
          type: this.FORM_TYPE.AUTO_COMPLETE,
          items: this.listOfOrders,
          select_text: 'numberWithName',
          term: 'searchOrder',
          keyup: this.loadOrders,
          select_value: 'id',
          label: this.$t('message.warehouse.orderRepo'),
          disabled: false,
          loading: this.orderLoading,
          class: 'lg4 md4 sm6',
          change: this.setTypeOfOrder
        }, {
          model: 'estimated_internal_cost',
          type: this.FORM_TYPE.NUMBER,
          rules: [],
          readonly: true,
          label: this.$t('message.deviations.estimatedInternalCost'),
          class: 'lg2 md4 sm4',
          change: this.changesMade
        }, {
          model: 'estimated_customer_cost',
          type: this.FORM_TYPE.NUMBER,
          rules: [],
          readonly: true,
          label: this.$t('message.deviations.estimatedCustomerCost'),
          class: 'lg2 md4 sm4',
          change: this.changesMade
        }, {
          model: 'date',
          type: this.FORM_TYPE.DATEPICKER,
          label: this.$t('message.order.date'),
          class: 'lg2 md4 sm4',
          picker: 'datePicker',
          menu: 'dateMenu',
          color: 'primary lighten-1',
          change: this.changesMade
        }, {
          model: 'deadline',
          rules: [],
          type: this.FORM_TYPE.DATEPICKER,
          class: 'lg2 md4 sm4',
          picker: 'dateProdPicker',
          menu: 'dateProdMenu',
          color: 'primary lighten-1',
          label: this.$t('message.order.deadlineDate'),
          change: this.changesMade
        }, {
          model: 'completeddate',
          rules: [],
          type: this.FORM_TYPE.DATEPICKER,
          class: 'lg2 md4 sm4',
          picker: 'completedDatePicker',
          menu: 'completedDateMenu',
          color: 'primary lighten-1',
          label: this.$t('message.common.completed'),
          change: this.changesMade
        }, {
          model: 'status_id',
          type: this.FORM_TYPE.AUTO_COMPLETE,
          rules: this.$_requiredValidation,
          items: this.listOfDevationStatus,
          term: 'status_id',
          click: (term) => this.supportingList(this.DEVIATION_STATUS, term),
          is_list: true,
          select_text: 'name',
          select_value: 'id',
          label: this.$t('message.tickets.status'),
          class: 'lg2 md4 sm4',
          change: this.checkIfStatusIsClosed
        }, {
          model: 'reported_by',
          type: this.FORM_TYPE.TEXT,
          rules: this.$_requiredValidation,
          label: this.$t('message.deviations.reported_by'),
          class: 'lg2 md4 sm6',
          change: this.changesMade
        }, {
          model: 'responsible_id',
          type: this.FORM_TYPE.AUTO_COMPLETE,
          rules: this.$_requiredValidation,
          items: this.listUsers,
          is_list: false,
          term: '',
          select_text: 'fullname',
          select_value: 'id',
          label: this.$t('message.deviations.responsible'),
          class: 'lg3 md4 sm6',
          change: this.changesMade
        }, {
          model: 'copy_to',
          type: this.FORM_TYPE.AUTO_COMPLETE,
          rules: [],
          items: this.listUsers,
          multiple: true,
          is_list: false,
          term: '',
          select_text: 'fullname',
          select_value: 'id',
          label: this.$t('message.deviations.copy_to'),
          class: 'lg4 md4 sm6',
          change: this.changesMade
        }, {
          model: 'severity',
          type: this.FORM_TYPE.AUTO_COMPLETE,
          rules: this.$_requiredValidation,
          items: this.$_deviationSeverity,
          is_list: false,
          term: '',
          select_text: 'text',
          select_value: 'value',
          label: this.$t('message.severity.select'),
          class: 'lg3 md4 sm6',
          change: this.changesMade
        }, {
          model: 'description',
          type: this.FORM_TYPE.TEXTAREA,
          rules: [],
          label: this.$t('message.customer.description'),
          class: 'lg4 md6 xs12',
          rows: 3,
          change: this.changesMade
        }, {
          model: 'actions',
          type: this.FORM_TYPE.TEXTAREA,
          rules: [],
          label: this.$t('message.tickets.actions'),
          class: 'lg4 md6 xs12',
          rows: 3,
          change: this.changesMade,
          is_visible: !!this.modelObj.id && !!this.modelObj.actions
        }, {
          model: 'reason',
          type: this.FORM_TYPE.TEXTAREA,
          rules: [],
          label: this.$t('message.deviations.reason'),
          class: 'lg4 md6 xs12',
          rows: 3,
          change: this.changesMade,
          is_visible: !!this.modelObj.id && !!this.modelObj.reason
        }, {
          model: 'underlying_reason',
          type: this.FORM_TYPE.TEXTAREA,
          rules: [],
          label: this.$t('message.deviations.underlying_reason'),
          class: 'lg4 md6 xs12',
          rows: 3,
          change: this.changesMade,
          is_visible: !!this.modelObj.id && !!this.modelObj.underlying_reason
        }, {
          model: 'corrective_actions',
          type: this.FORM_TYPE.TEXTAREA,
          rules: [],
          label: this.$t('message.deviations.corrective_actions'),
          class: 'lg4 md6 xs12',
          rows: 3,
          change: this.changesMade,
          is_visible: !!this.modelObj.id && !!this.modelObj.corrective_actions
        }, {
          model: 'effective_of_measures',
          type: this.FORM_TYPE.TEXTAREA,
          rules: [],
          label: this.$t('message.deviations.effective_of_measures'),
          class: 'lg4 md6 xs12',
          rows: 3,
          change: this.changesMade,
          is_visible: !!this.modelObj.id && !!this.modelObj.effective_of_measures
        }],
        buttons: [{
          name: 'saveupdate_handler',
          color: 'success',
          label: this.$route.params.deviation_id ? this.$t('message.common.update') : this.$t('message.common.save'),
          click: () => this.saveUpdateHandler(this.SAVE),
          loading: this.loading,
          is_show: true
        }, {
          name: 'updateclose_handler',
          color: 'primary',
          label: this.$t('message.common.updateAndClose'),
          click: () => this.saveUpdateHandler(this.UPDATE_CLOSE),
          loading: this.loading,
          is_show: this.$route.params.deviation_id
        }, {
          name: 'back_to_list',
          color: 'info',
          // eslint-disable-next-line
          click: this.navigationToList,
          label: this.$t('message.common.backToList'),
          is_show: true
        }, {
          name: 'delete_btn',
          color: 'error',
          label: this.$t('message.common.delete'),
          click: this.deleteHandler,
          is_show: this.$route.params.deviation_id
        }, {
          name: 'generate_pdf',
          color: 'grey',
          click: () => this.generateReport(),
          label: this.$t('message.deviations.genertate_pdf_with_attachment'),
          loading: this.downloadLoading,
          is_show: this.modelObj.id
        }, {
          name: 'share',
          color: 'primary',
          click: this.shareReport,
          label: this.$t('message.order.share'),
          // loading: this.downloadLoading,
          is_show: this.modelObj.id
        }]
      }
      return props
    }
  },
  watch: {
    'modelObj.dateProdPicker' (val) {
      if (val) {
        this.modelObj.deadline = this.$formatter.formatDate(val, 'YYYY-MM-DD', 'DD.MM.YYYY')
      }
    },
    'modelObj.completedDatePicker' (val) {
      if (val) {
        this.modelObj.completeddate = this.$formatter.formatDate(val, 'YYYY-MM-DD', 'DD.MM.YYYY')
      }
    },
    'modelObj.datePicker' (val) {
      if (val) {
        this.modelObj.date = this.$formatter.formatDate(val, 'YYYY-MM-DD', 'DD.MM.YYYY')
      }
    }
  },
  mounted () {
    this.$store.dispatch('getUsers').then(response => {
      this.setUsersFullname()
    })
    this.$store.dispatch('getDeviationStatus').then(() => {
      if (!this.modelObj.id) {
        this.setDefaultValues({ prop: 'status_id', list: this.listOfDevationStatus })
      }
    })
    this.$store.dispatch('getDeviationLocation').then(() => {
      if (!this.modelObj.id) {
        this.setDefaultValues({ prop: 'location_id', list: this.listOfDevationLocation })
      }
    })
    this.$store.dispatch('getDeviationCategory').then(() => {
      if (!this.modelObj.id) {
        this.setDefaultValues({ prop: 'category_id', list: this.listOfDevationCategory })
      }
    })

    this.$root.$on('get_deviation_details', () => {
      this.canReloadDocument = true
      this.getSingleRecordHandler()
    })

    if (!this.modelObj.id && this.$route.query.orderId) {
      this.getSingleOrder(this.$route.query.orderId)
    }
    if (this.modelObj.id) {
      this.getSingleRecordHandler()
    } else {
      this.modelObj.reported_by = this.userDetails ? this.userDetails.name : ''
    }
    let text = this.$t('message.common.deleteSuccess')
    this.$eventBus.$on('deleteSuccess', (data) => {
      if (data.module === this.MODULE_URL) {
        this.$root.$emit('snackbar', { snackbar: true, color: 'success', text })
        this.$store.commit('hideDialog')
        if (data.handler === 'item') {
          this.$router.push(`/${this.MODULE_URL}`)
        }
      }
    })
    this.$eventBus.$on('setItemInField', (data) => {
      let model = Object.assign({ ...this.modelObj }, { [data.modelName]: data.recordId })
      this.modelObj = model
    })
  },
  methods: {
    setDefaultValues (data) {
      let { list, prop } = data
      let item = list.find(x => x.is_default)
      if (item) {
        let model = Object.assign({ ...this.modelObj }, { [prop]: item.id })
        this.modelObj = model
      }
    },
    setUsersFullname () {
      let transformData = { merge: { list: ['firstname', 'lastname'], property: 'fullname' } }
      this.listUsers = this.$_formatListModel(this.listOfUsers, transformData)
    },
    supportingList (type, text) {
      const modelName = text
      text = this.$refs.deviationReference.$refs[text][0].lazySearch
      let model = { module: type, dialog: true, text, modelName }
      this.$store.commit('supportingList', model)
    },
    async getSingleRecordHandler () {
      this.fieldsLoading = true
      let model = {
        page: 1,
        ids: [this.modelObj.id],
        rowsperpage: 1
      }
      await this.checkDeviationHasMeasures()
      this.$_executeApi('post', `${this.MODULE_URL}/paginate_filter`, model)
        .then((response) => {
          let { items } = response.data
          if (items) {
            let model = this.$formatter.cloneVariable(items[0])
            model.copy_to = model.copy_to ? JSON.parse(model.copy_to) : null
            model.deadline = this.$formatter.formatDate(model.deadline, 'DD.MM.YYYYTHH:mm:ss', 'DD.MM.YYYY')
            model.completeddate = this.$formatter.formatDate(model.completeddate, 'DD.MM.YYYYTHH:mm:ss', 'DD.MM.YYYY')
            model.date = this.$formatter.formatDate(model.date, 'DD.MM.YYYYTHH:mm:ss', 'DD.MM.YYYY')
            model.closedon = this.$formatter.formatDate(model.closedon, 'DD.MM.YYYYTHH:mm:ss', 'DD.MM.YYYY')
            if (model.order_id) {
              var displayText = [model.ordernumber || '', model.ordersalesreference || '', model.ordercustomername || '']
              var orderRef = displayText.join(' - ')
              const orderId = model.iswarehouseorder ? `W_${model.order_id}` : `S_${model.order_id}`
              this.listOfOrders = [{ id: orderId, numberWithName: orderRef }]
              model.order_id = orderId
            }
            model.oldStatus = model.status_id
            this.modelObj = model
            if (this.canReloadDocument) this.reInit++
            this.canReloadDocument = false
          }
        })
        .finally(() => {
          this.fieldsLoading = false
        })
    },
    saveUpdateHandler (type) {
      if (this.$refs.deviationReference.$refs.validateForm.validate()) {
        this.loading = true
        let model = this.$formatter.cloneVariable(this.modelObj)
        if (!model.order_id) model.order_id = 0
        else {
          const orderId = model.order_id.split('_')[1]
          model.order_id = parseInt(orderId)
        }
        model.copy_to = model.copy_to ? JSON.stringify(model.copy_to) : null
        model.deadline = this.$formatter.formatDate(model.deadline, 'DD.MM.YYYY', 'YYYY-MM-DD')
        model.completeddate = this.$formatter.formatDate(model.completeddate, 'DD.MM.YYYY', 'YYYY-MM-DD')
        model.date = this.$formatter.formatDate(model.date, 'DD.MM.YYYY', 'YYYY-MM-DD')
        model.closedon = this.$formatter.formatDate(model.closedon, 'DD.MM.YYYY', 'YYYY-MM-DD')
        if (!model.estimated_internal_cost) model.estimated_internal_cost = 0
        if (!model.estimated_customer_cost) model.estimated_customer_cost = 0
        if (!model.order_id) model.order_id = 0
        let url = this.MODULE_URL
        this.$_saveUpdateHandler(url, model)
          .then((response) => {
            this.$store.commit('isChangesMade', false)
            if (type === this.SAVE && !model.id) {
              if (this.$route.query.orderId && +this.$route.query.orderId > 0) {
                this.$router.push(`/orders/edit/${this.$route.query.orderId}/deviations`)
              } else {
                this.$router.push(`/${this.MODULE_URL}/actions/${response.id}`)
              }
            } else if (type === this.UPDATE_CLOSE) {
              this.navigationToList()
            }
          })
          .finally(() => {
            this.loading = false
          })
      } else this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.common.validationIssue') })
    },
    loadOrders (term, event) {
      if ([30, 32, 37, 38, 39, 40].indexOf(event.keyCode) > -1) return
      let searchText = this.$refs.deviationReference.$refs[term][0].lazySearch
      if (searchText !== null) {
        this.loadOrdersHandler(searchText)
      }
    },
    getSingleOrder (id) {
      let query = {
        // expand: [{
        //   select: ['name'],
        //   model: 'Customer',
        //   on_field: 'id',
        //   on_parent_field: 'customerid'
        // }],
        'skip': 0,
        'limit': 1,
        'filter': `id eq ${id}`
      }
      this.$_executeApi('post', `orders/query`, query)
        .then((response) => {
          let order = response.data ? response.data[0] : {}
          if (!order) order = {}
          order.ordercustomerdata = order.ordercustomerdata ? JSON.parse(order.ordercustomerdata) : {}
          if (order.number) {
            var displayText = [order.number || '', order.salesreference || '', order.ordercustomerdata.Name || '']
            var title = [order.salesreference || '', order.ordercustomerdata.Name || '']
            var orderRef = displayText.join(' - ')
            this.listOfOrders = [{ id: `S_${id}`, numberWithName: orderRef }]
            this.modelObj.order_id = +this.$route.query.orderId ? `S_${this.$route.query.orderId}` : ''
            this.modelObj.title = (title || []).join(' - ')
          }
        })
    },
    loadOrdersHandler (searchText = '') {
      this.$_executeApi('post', `deviations/search_for_order_and_warehouseorders?term=${searchText}`).then((response) => {
        var list = response.data || []
        list.map(x => {
          var displayText = [x.number || '', x.salesreference || '', x.customername || '']
          x.numberWithName = displayText.join(' - ')
          return x
        })
        this.listOfOrders = list
      })
    },
    setTypeOfOrder () {
      const orderId = this.modelObj.order_id
      const modulePrefix = orderId.split('_')[0] // 'S' or 'W'
      var isWarehouseOrder = modulePrefix === 'W'
      this.modelObj.iswarehouseorder = isWarehouseOrder
    },
    checkIfStatusIsClosed () {
      const status = this.listOfDevationStatus.find(x => x.id === this.modelObj.status_id && x.isclosed)
      if (status) {
        if (!this.hasMeasures) {
          this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.deviations.measureExists') })
          setTimeout(() => {
            this.resetStatus()
          }, 200)
        } else {
          // check if there are open measures available, if yes then closing of deviation is not possible!
          this.openDeviationMeasuresAvailable()
            .then((response) => {
              if (response.data) {
                // open measures exists!
                this.resetStatus()
                this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.deviations.openMeasureExists') })
              } else {
                // deviation can be closed
                // set current date
                this.modelObj.closedon = this.$_getCurrentDate()
              }
            })
        }
      }
      this.changesMade()
    },
    resetStatus () {
      if (this.modelObj.oldStatus === this.modelObj.status_id) this.modelObj.status_id = 0
      else this.modelObj.status_id = this.modelObj.oldStatus || 0
    },
    openDeviationMeasuresAvailable () {
      return this.$_executeApi('get', `deviationmeasures/check_if_open_measures_available/${this.modelObj.id}`)
    },
    deleteHandler () {
      let ids = [this.modelObj.id]
      let payload = { ids, url: `${this.MODULE_URL}/delete_multiple`, module: { module: this.MODULE_URL, handler: 'item' } }
      this.$store.commit('showDeleteDialog', payload)
    },
    changesMade () {
      this.$store.commit('isChangesMade', true)
    },
    async generateReport () {
      this.downloadLoading = true
      var deviationIds = [this.modelObj.id] || []
      var content = await this.genereateReportContent(deviationIds)
      const model = {
        filetype: 'pdf_with_attachment',
        ids: deviationIds,
        pdfcontent: { content }
      }
      this.$_executeApi('post', 'deviations/generate_report', model).then(response => {
        this.downloadLoading = false
        const fileName = response.data
        window.open(axios.defaults.baseURL + 'file/download/?fileName=' + fileName, '_blank')
      }).finally(() => {
        this.downloadLoading = false
      })
    },
    async shareReport () {
      this.getInvoiceSettings()
        .then(() => {
          const { mail_signature } = this.$formatter.cloneVariable(this.settingsObj)
          this.shareDialog = true
          /* Set template data */
          // const footerTemplate = getFooter()
          this.mail.body = mail_signature
          this.mail.subject = `Avvik ${this.modelObj.number} - ${this.modelObj.title || ''}`
        })
    },
    getInvoiceSettings () {
      return this.$_getSingleRecordHandler('invoicesettings')
        .then((result) => {
          if (result.data) this.settingsObj = result.data
        })
    },
    closeShareDialog () {
      this.mail = {}
      this.shareDialog = false
    },
    async sendReport () {
      if (this.$refs.sendEmailForm.validate()) {
        let isValidEmail = false
        if (!this.mail.emailIds.length > 0) isValidEmail = true
        let getMailIDsString = this.mail.emailIds
        let listOfMailIds = getMailIDsString.split(',')
        if (listOfMailIds && listOfMailIds.length > 0) {
          for (let i = 0; i < listOfMailIds.length; i++) {
            if (listOfMailIds[i]) {
              listOfMailIds[i] = listOfMailIds[i].trim()
              this.validEmail(listOfMailIds[i]) ? isValidEmail = false : isValidEmail = true
            }
          }
        }
        const model = {}
        if (!isValidEmail) {
          this.shareLoading = true
          model.to = listOfMailIds
          model.subject = this.mail.subject
          model.body = this.mail.body
          model.ids = [this.modelObj.id]
          model.filesendType = 1
          var content = await this.genereateReportContent([this.modelObj.id])
          model.pdfcontent = { content }
          this.$_executeApi('post', 'deviations/share', model).then(() => {
            this.$root.$emit('snackbar', { snackbar: true, color: 'success', text: this.$t('message.tickets.sentSuccess') })
            this.mail = {}
            this.shareDialog = false
          }).finally(() => {
            this.shareLoading = false
          })
        } else this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.common.invalidEmail') })
      } else this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.common.invalidEmail') })
    },
    navigationToList () {
      if (this.$route.query.orderId && +this.$route.query.orderId > 0) {
        this.$router.push(`/orders/edit/${this.$route.query.orderId}/deviations`)
      } else {
        this.$router.push(`/${this.MODULE_URL}`)
      }
    },
    checkDeviationHasMeasures () {
      return this.$_executeApi('get', `deviationmeasures/has_any_measures/${this.modelObj.id}`)
        .then(({ data }) => {
          this.hasMeasures = data
          this.measurePanel = data ? 0 : -1
        })
    },
    /* eslint-disable */
    validEmail: function (email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(email)
    }
  },
  beforeRouteLeave (to, from, next) {
    if (!this.$store.state.isChangesMade) {
      next()
    } else {
      this.$store.commit('isChangesMade', true)
      this.$store.commit('changeLostDialog', true)
    }
  },
  beforeDestroy () {
    this.$eventBus.$off('deleteSuccess')
    this.$eventBus.$off('setItemInField')
    this.$root.$off('get_deviation_details')
  }
}
</script>
